import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'components/Button/Button'
import { DataGrid } from 'components/DataGrid/DataGrid'
import { Loading } from 'components/Loading/loading'
import { ModalForm } from 'components/ModalForm/ModalForm'
import { Search } from 'components/Search/Search'
import { Textbox } from 'components/Textbox/Textbox'
import { getItemGroup, getItemGroupRootsFormat, getItemGroupTree } from 'pages/InventoryAndSales/Inventory/ItemTree/api'
import { ItemsForSell } from 'pages/InventoryAndSales/Sales/components/ItemsForSell/ItemsForSell'
import React, { useEffect, useRef, useState } from 'react'
import { ICON_TYPE } from 'utils/constants'
import { getPageSize, trans } from 'utils/helpers'

function Items({mode,property,setCodeCallback}) {
  const [data, setData] = useState<any>()
  const [forceUpdate, setForceUpdate] = useState<boolean>(false)
  const [selectedObj, setSelectedObj] = useState<any>()
  const [showProperties, setShowProperties] = useState<any>()
  const [showBarcode, setShowBarcode] = useState<any>()
  const [showTax, setShowTax] = useState<any>()
  const [idCallback, setIdCallback] = useState<any>(null)
   

  const [newObj,setNewObj]=useState<any>()

  const [loading, setLoading] = useState<boolean>(false);
  const [ShowItemTreeDetail, setShowItemTreeDetail] = useState<boolean>(false);
  const [showForm, setShowForm] = useState<any>(0);
  const [checkData, setCheckData] = useState<any>(0);
  const [rootsFormat, setRootsFormat] = useState<any>(false);
  const [message, setMessage] = useState<any>("NoDataForPreview");
  const [showAttachment, setShowAttachment] = useState(false);
  const [typeTax,seTypeTax]=useState<any>(1)
  const [showMode, setShowMode] = useState<any>(null);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [pages, setPages] = useState<number>(0);
  const [levels, setLevels] = useState("");
  const [orderBy, setOrderBy] = useState<any>([]);
  const [search, setSearch] = useState<any>(null);
  const [showTree, setShowTree] = useState<any>();
  const ref=useRef<any>()

  
  const [filterlist, setFilterlist] = useState<any>("");

  const searchHandler = (str) => {
    setPageNum(1);
    setSelectedObj(null);
    if (!str) {
      setSearch(null);
    } else {
      setSearch(str);    
    }
  };

  const handlechangePageSize = (e: any) => {
    setPageNum(1);
    setPageSize(e.currentTarget.value);
    getPageSize("ItemTreeGrid" ,e.currentTarget.value )
    getItemTreeAsync(1)
  };

const handleGoPage = (value) => {
  if (value) {
    if (value < 1 || value > pages) { }
    else setPageNum(+value);getItemTreeAsync(+value)
  } else {

  }
};
const handleNextPage = () => {
    if(pageNum < pages){
        setPageNum(pageNum + 1);
        getItemTreeAsync(pageNum + 1);
      };
};
const handlePrevPage = () => {
    if(pageNum > 1){
        setPageNum((pageNum)=>{return +pageNum - 1});
        getItemTreeAsync(pageNum - 1);
      };
};


          async function getItemTreeAsync(PageNum = pageNum, ) {
    setLoading(false)
    let pageSizeChangedByUser = getPageSize("ItemTreeGrid" )
    setPageSize(pageSizeChangedByUser)
    try{
    //   if(showMode){
    //     const respons = await getItemGroupTree(null)
    //     setData(respons.Data)
    //   }else{
        let warehouseId=null
        const respons = await getItemGroup( warehouseId ,PageNum,  pageSizeChangedByUser ,orderBy.length == 0 ?null:  orderBy.join(",") ,search,filterlist)
        setPages(respons.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(respons.Data.TotalRecords / pageSizeChangedByUser) : 1) ;
        setData(respons.Data)
    // }

    }catch(err:any){
      setMessage(err?.data?.Message)
    }
   
    setLoading(true)
  }


  const setselecetrow = (e) => {
    setSelectedObj(e)
  }


    useEffect(() => {
    
       if(
        showTree
       )
       { getItemTreeAsync()}
      
    }, [forceUpdate  , showTree, search , filterlist , orderBy]);



    


  return (


    <>
      {showTree && (
            <ModalForm
              mode={mode}
              title="ItemTree"
              onHide={() => setShowTree(false)}
             show={showTree}
            >
                    <div className="col-lg-12 my-1 btns_form">
          <Button
            value="select"
            btnType="submit"
            onClick={(e) => {
             setCodeCallback(selectedObj,property?.SystemKey)
             setShowTree(false)
              
            }}
          />
          <Button
            btnType="cancel"
            value="Cancel"
            onClick={(e) => {
             setShowTree(false)
            }}
          />
        </div>
         <div className="col col-sm-4 col-md-3 mt-1 mb-3">
                 <Search
                 defultSerach={search as any}
                   onChange={searchHandler}
                   autoSearch={true}
                   autoFocus={true}
                 />
             </div>
            {loading?data?.Data ?
                                  <DataGrid
                                      parentName={"ItemTreeGrid"}
                                      theadData={Object.keys(data.Data[0])}
                                      tbodyData={data.Data}
                                      minCellWidth={80}
                                      DoubleClick={()=>{
              setCodeCallback(selectedObj,property?.SystemKey)
             setShowTree(false)
                                      }}
                                      selectedRowObjectCallback={(e)=>{  setselecetrow({...e , IsLeaf:true,ParentsList:[]})}}
                                      totalRecords={data.TotalRecords}
                                      pageNum={pageNum}
                                      orderFormat={setOrderBy}
                                      orderFormatList={orderBy}
                                      handlefiltering={(str)=>{setFilterlist(str)  }}
                                      filterStr={filterlist}
                                      pageSize={pageSize}
                                      HandleNextPage={handleNextPage}
                                      HandlePrevPage={handlePrevPage}
                                      handlechangePageSize={handlechangePageSize}
                                      first={() => {getItemTreeAsync(pages);setPageNum(pages)}}
                                      end={() => {getItemTreeAsync(1);setPageNum(1)}}
                                      handleGoPage={handleGoPage}
                                      useChangingNumberPlacement={true}
                                     />
                                   :
                                   <></>:<Loading/>
                                   }
            </ModalForm>
          )}
    
    
      <div
            
                     style={{
                       display: "flex",
                       alignItems: "center",
                       flexDirection: "row",
                     }}
                   >
                     <Textbox
                     useOnInput={true}
                       required={property?.required}
                       labelText={trans(property?.label)}
                       textboxName={property?.SystemKey}
                       textboxType="text"
                       mode={mode}
                       value={idCallback?idCallback:property?.defaultValue ? property?.defaultValue : null}
                       defaultValue={property?.defaultValue ? property?.defaultValue : null}
                     />
                     {mode != "view" && (
                       <div style={{ marginTop: "4px", width: "10%" }}>
                         <Button
                           Icon={true}
                           value={
                             <button
                               onClick={(e) => setShowTree(true)}
                               type="button"
                               className="checkButton d-flex align-items-center justify-content-center"
                             >
                               {" "}
                               <FontAwesomeIcon
                                 icon={[ICON_TYPE, "diagram-project"]}
                                 size="1x"
                               />
                             </button>
                           }
                           btnType="primary"
                          // onClick={(e) => setShowTree(true)}
                         />
                       </div>
                     )}
                
                   </div>
    </>
 

  )
}

export default Items